<template>
  <div class="p-fluid" style="direction: rtl">
    <div class="card  p-d-flex p-jc-center">
      <DataTable
          :rowClass="rowClass"
          sortMode="multiple"
          removableSort
          :value="data"
          :paginator="true"
          :selection.sync="selectedItemsUser"
          :resizableColumns="false"
          @cell-edit-complete="onCellEditComplete"
          columnResizeMode="fit"
          dataKey="id"
          class="
          p-datatable-customers
          p-datatable-sm
          p-datatable-gridlines
          p-datatable-striped
        "
          :rows="50"
          stateStorage="local"
          stateKey="user-data-state"
          editMode="cell"
          :filters="filters"
          :loading="loading"
          sortField="lastname"
          :sortOrder="1"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[ 20, 50, 200, 1000]"
          currentPageReportTemplate="מציג {first} עד {last} מתוך {totalRecords}"
      >
        <!-- header -->

        <template #header>
          <div class="p-p-2 table-header">
            <div class="p-m-1 p-d-inline-flex">
              <h1 style="text-align: center">   <i style=" transform: scale(1.7); " class="p-p-3 pi pi-id-card"></i>| משתמשים</h1>
            </div>

            <div class="p-d-flex">
              <span class="p-mr-2 p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                    v-model="filters['global']"
                    placeholder="חיפוש ראשי"
                />
              </span>
              <Button
                  v-tooltip.top="'מחיקה'"
                  v-if="selectedItemsUser.length > 0 && selectedItemsUser.length < 5"
                  icon="pi pi-trash"
                  class="p-mr-2 p-button-danger "
                  @click="isDialogDelete = true"
              />
              <Button
                  v-tooltip.top="'ניתן למחוק\n רק עד 5 פריטים'"
                  v-if="selectedItemsUser.length >= 5"
                  icon="pi pi-trash"

                  class="p-mr-2 p-button-secondary"
              />
              <Button
                  v-tooltip.top="'הוספה'"
                  icon="pi pi-plus"
                  class="p-mr-2 p-button-success"
                  @click="isDialogAdd = true"
              />
            </div>
          </div>
        </template>
        <template #loading> טוען נתונים מהמערכת, אנא המתן... </template>

        <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
        <!-- id -->

        <Column
            bodyStyle="text-align: right; overflow: visible; color: #757575;"
            field="id"
            header="ת.ז"
            sortable
        >
          <template #filter>
            <InputText
                type="text"
                v-model="filters['id']"
                class="p-column-filter"
                placeholder="חפש לפי ת.ז."
            />
          </template>
        </Column>

        <!-- grade -->

        <Column
            headerStyle="width: 8%; text-align: rtl"
            bodyStyle="text-align: right;"
            field="grade"
            header="כיתות"
            filterMatchMode="in"
            filterField="grade"
            sortable
            sortField="grade.hebrewName"
        >
          <template #filter>
            <MultiSelect
                v-model="filters['grade']"
                :options="gradeOptions"
                :showClear="true"
                placeholder="סנן לפי כיתה"
                class="multiselect-custom"
            >
              <template #option="slotProps">
                <span>{{ slotProps.option.hebrewName }}</span>
              </template>
              <template #value="slotProps">
                <div v-if="!slotProps.value || slotProps.value.length === 0">
                  {{ slotProps.placeholder }}
                </div>
                <span v-else>
                  <span v-for="a in slotProps.value" :key="a.id">
                    {{ a.hebrewName }},
                  </span>
                </span>
              </template>
            </MultiSelect>
          </template>

          <template #editor="slotProps">
            <Dropdown
                optionLabel="hebrewName"
                v-if="slotProps.data.enabled === true"
                :value="slotProps.data[slotProps.column.field]"
                :options="gradeOptions"
                placeholder="בחר כיתה"
                @input="onCellEdit($event, slotProps)"
            >
              <template #value="slotProps">
                <div v-if="!slotProps.value || slotProps.value.length === 0">
                  {{ slotProps.placeholder }}
                </div>
                <span v-else> {{ slotProps.value.hebrewName }} </span>
              </template>
              <template #option="slotProps">
                <span>{{ slotProps.option.hebrewName }}</span>
              </template>
            </Dropdown>
            <div v-else>{{ slotProps.data.grade.hebrewName }}</div>
          </template>

          <template  #body="slotProps">
            <div v-if="slotProps.data.grade !== undefined">
            {{ slotProps.data.grade.hebrewName }}
            </div>
            <div v-else><hr></div>
          </template>
        </Column>

        <!-- v-for -->

        <Column
            headerStyle="text-align: rtl"
            bodyStyle="text-align: right; overflow: visible"
            sortable
            v-for="col of columns"
            :field="col.field"
            :header="col.header"
            :key="col.field"
        >
          <template #filter>
            <InputText
                type="text"
                v-model="filters[col.field]"
                class="p-column-filter"
                :placeholder="`חפש לפי ${col.header}`"
            />
          </template>
          <template #editor="slotProps">
            <InputText
                v-if="slotProps.data.enabled === true"
                :value="slotProps.data[slotProps.column.field]"
                @input="onCellEdit($event, slotProps)"
            />
            <div v-else>{{ slotProps.data[slotProps.column.field] }}</div>
          </template>
        </Column>

        <!-- InputNumber -->

        <Column
            field="amountReports"
            header="דיווחים"
            filterMatchMode="equals"
            filterField="amountReports"
            sortable
            sortField="amountReports"
            headerStyle=" width: 8%; text-align: rtl"
            bodyStyle="text-align: right; overflow: visible"
            :key="'amountReports'"
        >
          <template #filter>
            <InputText
                type="text"
                v-model="filters['amountReports']"
                class="p-column-filter"
                :placeholder="`חפש לפי כמות`"
            />
          </template>
          <template #editor="slotProps">
            <InputNumber
                v-if="slotProps.data.enabled === true"
                :value="slotProps.data[slotProps.column.field]"
                @input="onCellEdit($event, slotProps)"
            />
            <div v-else>{{ slotProps.data.amountReports }}</div>
          </template>
          <template #body="slotProps">
            {{ slotProps.data.amountReports }}
          </template>
        </Column>

        <!-- role -->

        <Column
            headerStyle="width: 8%; text-align: rtl"
            bodyStyle="text-align: right; overflow: visible"
            sortable
            sortField="role"
            :field="'role'"
            :header="'הרשאה'"
            :key="'role'"
            filterMatchMode="in"
        >
          <template #filter>
            <MultiSelect
                v-model="filters['role']"
                :options="roles"
                :showClear="true"
                placeholder="סנן לפי הרשאה"
                class="multiselect-custom"
            >
              <template #option="slotProps">
                <span>{{ getRoleLabel(slotProps.option) }}</span>
              </template>
              <template #value="slotProps">
                <div v-if="!slotProps.value || slotProps.value.length === 0">
                  {{ slotProps.placeholder }}
                </div>
                <span v-else>
                  <span v-for="a in slotProps.value" :key="a">
                    {{ getRoleLabel(a) }},
                  </span>
                </span>
              </template>
            </MultiSelect>
          </template>
          <template #editor="slotProps">
            <Dropdown
                v-if="slotProps.data.enabled === true"
                :value="slotProps.data[slotProps.column.field]"
                :options="roles"
                @input="onCellEdit($event, slotProps)"
            >
              <template #option="slotProps">
                <span>{{ getRoleLabel(slotProps.option) }}</span>
              </template>
              <template #value="slotProps">
                <div v-if="slotProps.value">
                  <span>{{ getRoleLabel(slotProps.value) }}</span>
                </div>
                <span v-else>
                  {{ slotProps.placeholder }}
                </span>
              </template>
            </Dropdown>
            <div v-else>{{ getRoleLabel(slotProps.data.role) }}</div>
          </template>
          <template #body="slotProps">
            {{ getRoleLabel(slotProps.data.role) }}
          </template>
        </Column>

        <!-- enabled -->

        <Column
            field="enabled"
            header="פעיל"
            filterField="enabled"
            sortable
            sortField="enabled"
            headerStyle="width: 8%; text-align: center"
            bodyStyle="text-align: center; overflow: visible"
            filterMatchMode="equals"
        >
          <template #filter>
            <Dropdown
                :showClear="true"
                v-model="filters['enabled']"
                :options="enabled"
                :optionLabel="enabled"
                placeholder="סנן לפי פעילות"
            >
              <template #option="slotProps">
                <span>{{ getEnabledLabel(slotProps.option) }}</span>
              </template>
              <template #value="slotProps">
                <div v-if="!slotProps.value || slotProps.value.length === 0">
                     {{slotProps.placeholder}}
                </div>
                <div v-else>{{ getEnabledLabel(slotProps.value) }}</div>
              </template>
            </Dropdown>
          </template>

          <template #editor="slotProps">
            <Dropdown
                :value="slotProps.data[slotProps.column.field]"
                :options="enabled"
                @input="onCellEdit($event, slotProps)"
            >
              <template #option="slotProps">
                <span>{{ getEnabledLabel(slotProps.option) }}</span>
              </template>
              <template #value="slotProps">
                <span>{{ getEnabledLabel(slotProps.value) }}</span>
              </template>
            </Dropdown>
          </template>

          <template #body="slotProps">
            {{ getEnabledLabel(slotProps.data.enabled) }}
          </template>
        </Column>

        <template #footer>
          סה״כ {{ data ? data.length : 0 }} משתמשים.
        </template>
      </DataTable>
    </div>

    <add-Dialog
        :show="isDialogAdd"
        v-on:addItem="addItem"
        v-on:closeDialog="isDialogAdd = false"
    >
    </add-Dialog>
    <delete-dialog
        :title="'מחיקת משתמש'"
        :context="`האם תרצה להסיר ${selectedItemsUser.length} משתמשים מהמערכת?`"
        :show="isDialogDelete"
        v-on:choice="deleteItem"
    >
    </delete-dialog>
  </div>
</template>

<script>
import AddDialog from "../../dialogs/UserDialog.vue";
import deleteDialog from "../../dialogs/DeleteDialog.vue";
import Service from "../../service/Service";
import Vue from "vue";
import {mapState} from "vuex";

export default {
  service: null,
  components: {
    AddDialog,
    deleteDialog,
  },
  created() {
    this.service = new Service();
    setTimeout(() => {
      this.selectedItemsUser = []
    }, 500)
  },
  mounted() {
    this.service.get(this.ENTITY).then((data) => {
      this.data = data;
      data.forEach((element) => {
        element.grade = this.getGradeObj(element.grade);
      });
      this.loading = false;
    });

  },
  data() {
    return {
      ENTITY: 'user',

      data: null,
      loading: true,
      isDialogDelete: false,
      isDialogAdd: false,
      selectedItemsUser: [],
      filters: {},
      itemBeforeEditing: {},
      itemAfterEditing: {},
      roles: ["USER", "MIKTZOI", "ADMIN"],
      columns: [
        {field: "password", header: "סיסמא"},
        {field: "firstname", header: "שם פרטי"},
        {field: "lastname", header: "שם משפחה"},
      ],
      enabled: [true, false],
      b: "1",
    };
  },
  computed: {
    ...mapState(["gradeOptions"]),
  },
  methods: {
    getGradeObj(gradeId) {
      return this.gradeOptions?.find((grade) => grade.id === gradeId);
    },
    rowClass(data) {
      return data.enabled === false ? "row-unenabled" : null;
    },
    addItem(item) {
      this.data.push(item);
    },
    deleteItem(choice) {
      this.isDialogDelete = false;
      if (choice) {
        this.loading = true

        const itemsIds = [];
        const selscteds = this.selectedItemsUser;
        this.selectedItemsUser.forEach((item) => {
          itemsIds.push(item.id);
        });

        this.service.deleteMany(itemsIds, this.ENTITY)
            .then(() => {
              this.loading = false
              this.openNotification("success", `מעולה`, `מחקנו ${itemsIds.length}  רשומות מהמערכת`);
              selscteds.forEach((selected) => {
                this.data = this.data.filter((item) => item.id !== selected.id);
              });
            })
        .catch(() => {
          // Vue.set(this.data, index, this.itemBeforeEditing);
          this.loading = false

          this.openNotification(
              "danger",
              `אופס`,
              `לא הצלחנו למחוק את הרשומות מהמערכת`
          );
        });

        this.isDialogDelete = false;
      }
      this.loading = false

      this.selectedItemsUser = [];
    },

    async onCellEditComplete(event) {
      const index = this.data.findIndex(
          (item) => item.id === this.itemAfterEditing.id
      );
      this.data[index] = this.itemAfterEditing;

      Vue.set(this.data, index, this.itemAfterEditing);
      const clone = JSON.parse(JSON.stringify(this.itemAfterEditing));
      clone.grade = clone?.grade?.id
      this.service.update(clone, this.ENTITY)
          .then(() => {})
          .catch(() => {
            Vue.set(this.data, index, this.itemBeforeEditing);
            this.openNotification(
                "danger",
                `אופס`,
                `קרתה תקלה בעדכון הנתונים במערכת`
            );
          });
    },
    onCellEdit(newValue, props) {
      this.itemBeforeEditing = {...props.data};
      this.itemAfterEditing = {...props.data};
      this.itemAfterEditing[props.column.field] = newValue;
    },
    getRoleLabel(status) {
      switch (status) {
        case "ADMIN":
          return "מנהל";

        case "USER":
          return "מחנך";

        case "MIKTZOI":
          return "מקצועי";

        default:
          return "NA";
      }
    },
    getEnabledLabel(boolean) {
      switch (boolean) {
        case true:
          return "פעיל";

        case false:
          return "לא פעיל";

        default:
          return "NA";
      }
    },
    openNotification(color, title, text, position = "right-left", duration = 3000) {
      this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
    },
  },
};
</script>


<style scoped>
.p-multiselect-label:not(.p-placeholder) {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.app-container {
  text-align: center;
}
.p-paginator {
  direction: rtl;
}

.p-paginator-icon {
  transform: scaleX(-1);
}

td {
  text-align: right !important;
}

p {
  text-align: right !important;
}

h4 {
  text-align: right !important;
}

/*::v-deep .row-unenabled {*/
/*  color: rgba(0, 0, 0, 0.3) !important;*/
/*}*/

th {
  text-align: right !important;
}
</style>
